export enum Division {
	countdown = 'COUNTDOWN',
	countdownLiquor = 'COUNTDOWN_LIQUOR',
	countdownPharmacy = 'COUNTDOWN_PHARMACY',
}
